import {
    IntegerField,
    type AiGuideMathExpressionCopiedV1,
    type ContentLibraryMathExpressionCopiedV1,
} from "@khanacademy/event-schemas";
import {logUnreachableCode} from "@repo/logging";

export type Event =
    | AiGuideMathExpressionCopiedV1
    | ContentLibraryMathExpressionCopiedV1;

export interface EventParams {
    context: "ai-guide" | "content-library";
    tex: string;
    currentPageURL: string;
    /**
     * The math renderer that was used for the expressions related to this
     * event. You probably want to set this to "mathjax3"; MathJax 2 and
     * KaTeX were our old math renderers, and were removed from webapp in March
     * 2025.
     */
    renderer: "katex" | "mathjax2" | "mathjax3";
}

export function createEvent(params: EventParams): Event {
    const {context, renderer, currentPageURL, tex} = params;

    switch (context) {
        case "ai-guide":
            return {
                eventType: "AiGuideMathExpressionCopied",
                eventSchemaVersion: 1,
                currentPageURL,
                renderer,
                texLengthCharacters: new IntegerField(tex.length),
            };
        case "content-library":
            return {
                eventType: "ContentLibraryMathExpressionCopied",
                eventSchemaVersion: 1,
                currentPageURL,
                renderer,
                texExpression: tex,
            };
        default:
            throw logUnreachableCode("unexpected TeX event context", context);
    }
}
